// src/components/programs/ProgramForm/Step0Sections/BasicInfoSection.jsx

import React from "react";
import { Grid } from "@mui/material";
import FormInput from "../../../inputs/FormInput";
import CustomerNameInput from "../../../inputs/CustomerNameInput";
import SortableCitiesList from "./SortableCitiesList";

const BasicInfoSection = ({
    formData,
    errors,
    isArabic,
    activeLang,
    handleMultiLangChange,
    citiesOptions = [],
    loadingCities = false,
    onCityIdsChange,
    agentsOptions = [],
    loadingAgents = false,
    onFlatFieldChange,
}) => {
    return (
        <Grid container spacing={3} alignItems={'flex-end'}>
            {/* Title */}
            <Grid item xs={12} md={6}>
                <FormInput
                    label={isArabic ? 'اسم البرنامج' : 'Program Name'}
                    placeholder={isArabic ? 'أدخل اسم البرنامج' : 'Enter Program Name'}
                    value={formData.title?.[activeLang] || ''}
                    onChange={(e) => handleMultiLangChange('title', activeLang, e.target.value)}
                    error={!!errors[`title_${activeLang}`]}
                    helperText={errors[`title_${activeLang}`]}
                    required
                    multiline={false}
                />
            </Grid>

            {/* Description (Customer Name) */}
            <Grid item xs={12} md={6}>
                {/* <FormInput
                    label={isArabic ? 'اسم العميل' : 'Customer Name'}
                    placeholder={isArabic ? 'أدخل اسم العميل' : 'Enter customer name'}
                    value={formData.description?.[activeLang] || ''}
                    onChange={(e) => handleMultiLangChange('description', activeLang, e.target.value)}
                    multiline
                    rows={2}
                /> */}
                <CustomerNameInput
                    label={isArabic ? 'اسم العميل' : 'Customer Name'}
                    value={formData.description?.[activeLang] || ''}
                    onChange={(e) => handleMultiLangChange('description', activeLang, e.target.value)}
                    language={activeLang}
                    required
                    error={!!errors?.[`description_${activeLang}`]}
                    helperText={errors?.[`description_${activeLang}`] || ''}
                    fullWidth
                />
            </Grid>
            {/* Agent */}
            <Grid item xs={12}>
                <FormInput
                    label={isArabic ? 'الوكيل' : 'Agent'}
                    placeholder={isArabic ? 'اختر الوكيل' : 'Select Agent'}
                    type="select"
                    name="agent_id"
                    value={formData.agent_id || ''}
                    onChange={(e) => {
                        if (onFlatFieldChange) {
                            onFlatFieldChange('agent_id', e.target.value);
                        }
                    }}
                    options={agentsOptions}
                    loading={loadingAgents}
                    error={!!errors.agent_id}
                    helperText={errors.agent_id}
                    required
                />
            </Grid>

            {/* Cities */}
            <Grid item xs={12}>
                <FormInput
                    label={isArabic ? 'المدن' : 'Cities'}
                    placeholder={isArabic ? 'اختر المدن' : 'Select cities'}
                    type="multi_select"
                    value={formData.city_ids || []}
                    onChange={(value) => onCityIdsChange(value)}
                    options={citiesOptions}
                    loading={loadingCities}
                    error={!!errors.city_ids}
                    helperText={errors.city_ids}
                    required
                    showChips={false}
                />
                <SortableCitiesList
                    selectedIds={formData.city_ids || []}
                    citiesOptions={citiesOptions}
                    onReorder={(newOrder) => onCityIdsChange(newOrder)}
                    onRemove={(idToRemove) => {
                        const newIds = (formData.city_ids || []).filter(id => id !== idToRemove);
                        onCityIdsChange(newIds);
                    }}
                    isArabic={isArabic}
                />
            </Grid>
        </Grid>
    );
};

export default BasicInfoSection;
